import _ from 'underscore';
import { useCallback } from 'react';

export const LinkedInImageType = {
  Landscape: 'Image191x100',
  Square: 'Image1x1',
  Vertical: 'Image4x5',
};

export const LinkedInImageTypeAspectRatio = {
  [LinkedInImageType.Landscape]: 1.91,
  [LinkedInImageType.Square]: 1,
  [LinkedInImageType.Vertical]: 0.8,
};

export const CallToActionOptions = [
  { key: 'Apply', text: _TL_('Apply') },
  { key: 'Download', text: _TL_('Download') },
  { key: 'ViewQuote', text: _TL_('View Quote') },
  { key: 'LearnMore', text: _TL_('Learn More') },
  { key: 'SignUp', text: _TL_('Sign Up') },
  { key: 'Subscribe', text: _TL_('Subscribe') },
  { key: 'Register', text: _TL_('Register') },
  { key: 'Join', text: _TL_('Join') },
  { key: 'Attend', text: _TL_('Attend') },
  { key: 'RequestDemo', text: _TL_('Request Demo') },
];

export const getDefaultAd = ({
  connectedCompanyPage,
}) => {
  let finalUrl;
  if (connectedCompanyPage && connectedCompanyPage.Website) {
    if (!connectedCompanyPage.Website.startsWith('https://') && !connectedCompanyPage.Website.startsWith('http://')) {
      finalUrl = `https://${connectedCompanyPage.Website}`;
    } else {
      finalUrl = connectedCompanyPage.Website;
    }
  }

  return (
    {
      FinalUrls: finalUrl ? [finalUrl] : [],
      FinalUrlForRecommendation: finalUrl,
      SelectedImageType: 'Image191x100',
    });
};

export const getSelectedImageTypeFromModel = (model) => {
  const imageAsset = model.Images[0].Asset;
  const imageAssetAspectRatio = imageAsset.CropWidth / imageAsset.CropHeight;

  const selectedImageType = _.min(_.values(LinkedInImageType), imageType => (Math.abs(LinkedInImageTypeAspectRatio[imageType] - imageAssetAspectRatio)));
  return selectedImageType;
};

export const getCTAFromModel = (model) => {
  const cta = model.CallToAction;

  if (!cta) { return undefined; }

  const ctaOption = CallToActionOptions.find(option => option.key === cta);

  if (!ctaOption) { return undefined; }

  return {
    optionValue: ctaOption.key,
    optionText: ctaOption.text,
    selectedOptions: [ctaOption.key],
  };
};

const fixTextFormat = (text) => {
  if (!text) return undefined;

  let modifiedText = text;
  if (_.contains(modifiedText, ',') || _.contains(modifiedText, '"') || _.contains(modifiedText, '\n')) {
    modifiedText = `"${modifiedText}"`;
  }
  return modifiedText;
};

export const useLinkedInAdAdapter = () => {
  const mapToViewModel = useCallback(model => ({
    Id: model.Id,
    FinalUrls: model.FinalUrls,
    Images: { ImageAssets: model.Images },
    Headlines: { Headline0: model.Headline },
    Descriptions: { Description0: model.Text },
    CallToAction: getCTAFromModel(model),
    SelectedImageType: getSelectedImageTypeFromModel(model),
  }), []);

  const mapToBulkModel = useCallback((campaign, adGroup, adData, isDeleted = false) => {
    const imageList = _.map(adData.Images.ImageList, imageArray =>
      _.find(imageArray, imageObj => imageObj.type === adData.SelectedImageType));
    const flattenImageList = _.flatten(imageList, 1);

    const images = _.map(flattenImageList, image => ({
      id: image.idString || String(image.id),
      idString: image.idString || String(image.id),
      subType: image.associationType,
      cropX: image.cropSettings.SourceX,
      cropY: image.cropSettings.SourceY,
      cropWidth: image.cropSettings.SourceWidth,
      cropHeight: image.cropSettings.SourceHeight,
    }));

    const fields = {
      AdType: 'LinkedIn',
      Id: adData && adData.Id ? adData.Id : -1,
      FinalUrls: adData.FinalUrls,
      Images: JSON.stringify(images),
      Headline: adData.Headlines && adData.Headlines.Headline0 ? adData.Headlines.Headline0 : undefined,
      Text: fixTextFormat(adData.Descriptions && adData.Descriptions.Description0), // Introductory text
      Campaign: { Id: campaign.Id },
      AdGroup: { Id: adGroup.Id },
      CallToAction: adData.CallToAction ? adData.CallToAction.optionValue : undefined,
      CallToActionLanguage: 'None',
    };

    if (isDeleted) {
      fields.Status = 'Deleted';
    }

    return fields;
  }, []);

  return {
    mapToViewModel,
    mapToBulkModel,
  };
};
